import {useId} from '@wordpress/element'

function Award (props) {
	const {
		color1,
		color2,
		color3,
		score
	} = props

	const id1 = useId()
	const id2 = useId()
	const id3 = useId()


	let scoreInt = parseInt(score)
	if (isNaN(scoreInt)) scoreInt = ''


	return (
		<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
			<circle cx={50} cy={50} r={38} filter={`url(#${id1})`} fill={color2 || '#eda140'} />
			<circle
				cx={50}
				cy={50}
				r={44}
				filter={`url(#${id3})`}
				fill="none"
				stroke={color1 || '#f7e259'}
				strokeWidth={12}
			/>
			<text
				x={50}
				y={53}
				textAnchor="middle"
				dominantBaseline="middle"
				filter={`url(#${id2})`}
				fill={color1 || '#f7e259'}
				style={{
					font: "700 40px sans-serif"
				}}
				color={color1 || '#f7e259'}
			>
				{scoreInt}
			</text>
			<filter id={id1} data-iconmelon="filter:96c25f4e7a8a5b39d6df22c349dbaf39">
				<feOffset />
				<feGaussianBlur stdDeviation={1} result="offset-blur" />
				<feComposite
					operator="out"
					in="SourceGraphic"
					in2="offset-blur"
					result="inverse"
				/>
				<feFlood floodColor={color3 || '#c26a34'} floodOpacity={0.95} result="color" />
				<feComposite operator="in" in="color" in2="inverse" result="shadow" />
				<feComposite in="shadow" in2="SourceGraphic" />
			</filter>
			<filter id={id2} colorInterpolationFilters="sRGB">
				<feGaussianBlur stdDeviation={0.85} />
				<feOffset dx={0.5} dy={0.5} result="shadow" />
				<feFlood floodColor={color3 || '#c26a34'} floodOpacity={0.95} result="color" />
				<feComposite operator="in" in="color" in2="shadow" result="shadow2" />
				<feComposite in="SourceGraphic" in2="shadow2" />
			</filter>
			<filter id={id3} x="-25%" y="-25%" width="150%" height="150%">
				<feOffset
					in="SourceAlpha"
					dx={0.16666666666666666}
					dy={0.8333333333333334}
					result={17}
				/>
				<feGaussianBlur stdDeviation={0.5} in={17} result={18} />
				<feSpecularLighting
					specularConstant={0.9}
					specularExponent={15}
					in={18}
					result={19}
				>
					<fePointLight x={-1000} y={-5000} z={300} />
				</feSpecularLighting>
				<feComposite in={19} in2="SourceAlpha" operator="in" result={20} />
				<feOffset
					in="SourceAlpha"
					dx={-0.16666666666666666}
					dy={-0.8333333333333334}
					result={21}
				/>
				<feGaussianBlur stdDeviation={0.5} in={21} result={22} />
				<feSpecularLighting
					specularConstant={1.8}
					specularExponent={8}
					in={22}
					result={23}
				>
					<fePointLight x={100} y={5000} z={300} />
				</feSpecularLighting>
				<feComposite in={23} in2="SourceAlpha" operator="in" result={24} />
				<feColorMatrix
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .85 0"
					in={24}
					result={25}
				/>
				<feComposite
					k2={0.8}
					k3={0.5}
					in={20}
					in2={25}
					operator="arithmetic"
					result={26}
				/>
				<feMerge result={27}>
					<feMergeNode in="SourceGraphic" />
					<feMergeNode in={26} />
				</feMerge>
			</filter>
		</svg>
	)
}

export default Award
